import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { BaseIcon } from "../base-icon";
export var FilterIcon = function(_param) /*#__PURE__*/ {
    var color = _param.color, _size = _param.size, size = _size === void 0 ? 16 : _size, props = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    return _jsx(BaseIcon, _object_spread_props(_object_spread({}, props), {
        color: color,
        height: size,
        width: size,
        children: size === 16 ? /*#__PURE__*/ _jsx("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M8.539 5.25a3.335 3.335 0 0 1-6.411 0H.75a.75.75 0 0 1 0-1.5h1.3a3.334 3.334 0 0 1 6.566 0h6.634a.75.75 0 0 1 0 1.5H8.539Zm-1.372-.917a1.833 1.833 0 1 1-3.667 0 1.833 1.833 0 0 1 3.667 0ZM10.667 9a3.334 3.334 0 0 1 3.282 2.75h1.301a.75.75 0 0 1 0 1.5h-1.378l.002-.004a3.335 3.335 0 0 1-6.413.004H.75a.75.75 0 0 1 0-1.5h6.634A3.334 3.334 0 0 1 10.667 9Zm1.833 3.333a1.833 1.833 0 1 1-3.667 0 1.833 1.833 0 0 1 3.667 0Z",
            clipRule: "evenodd"
        }) : /*#__PURE__*/ _jsx("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M12.944 6.75a5.001 5.001 0 0 1-9.888 0H.75a.75.75 0 0 1 0-1.5h2.306a5.001 5.001 0 0 1 9.888 0H23.25a.75.75 0 0 1 0 1.5H12.944ZM11.5 6a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0ZM16 13a5.001 5.001 0 0 1 4.944 4.25h2.306a.75.75 0 0 1 0 1.5h-2.306a5.001 5.001 0 0 1-9.888 0H.75a.75.75 0 0 1 0-1.5h10.306A5.001 5.001 0 0 1 16 13Zm3.5 5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z",
            clipRule: "evenodd"
        })
    }));
};
